import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useUtils from "../../../../utiles/useUtiles";

interface Props {
  setStep: ( n: number ) => void, 
  csvUUID: string | null
}
const CreateTemplate: React.FC<Props> = ({ setStep, csvUUID }): JSX.Element => {

  const [csvDetails, setCsvDetails] = useState<any | null>( null );
  const [loading, setLoading] = useState<boolean>( false );
  const { axiosRequest, baseUrl, toastInstance } = useUtils()
  const axios = axiosRequest();
  const toast = toastInstance();

  useEffect( () => {
    fetchCsvDetails();
  }, [] );

  const fetchCsvDetails = async () => {
    setLoading( true );
		const request = await axios.get( `${baseUrl()}/template/uploaded/csv-details/${csvUUID}` );
    const { error, result, message } = request.data;
    setLoading( false );

		if ( error ) {
			toast.error( message );
		} else {
			setCsvDetails( result );
		}
	};

  return (
    <div className="main-card revrex-data-table-card">
        <h1 className="text-center mb-4">Uploaded CSV Data</h1>
        <div className="mb-4">
          <h5>1. Select a Point of Sales System</h5>
          <p>{csvDetails && csvDetails['csvType']['name']}</p>
          <h5>2. Select your CSV file</h5>
          <p>{csvDetails && csvDetails['csv']['originalName']}</p>
          <h5>3. Validate the information before you save it</h5>
        </div>
        <div>
          <div className="headers-panel">
              <h4>The headers are</h4>
              {
                csvDetails && csvDetails['csv']['headers'] && csvDetails['csv']['headers'].length && csvDetails['csv']['headers'].map( ( header: string, index: number ) => (
                  <div className="header-tags" key={index}>{header}</div>
                ) )
              }
          </div>
        </div>
        <div>
              <button data-cy="btnProccedToHeaderMapping" type="button" className="btn btn-md revrex-primary-btn mt-3" disabled={loading} onClick={() => setStep( 4 )}>
								<span>Proceed to header mapping</span>
							</button>
          {/* <a href="#" className="revrex-primary-btn" onClick={() => setStep(4)}>Create Template</a> */}
        </div>
    </div>
  );
}

export default CreateTemplate